import { useEffect, useRef, useState, memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "../../utils/const";
import CountUp from "react-countup";
import { useRouter } from "next/router";

function getDuration(value) {
  return value > 2000 ? 2 : 4;
}

function Statistics({ num, suffix, text, type }) {
  const router = useRouter();
  const { locale } = router;

  const [startCounting, setStartCounting] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setStartCounting(true);
          observer.disconnect(); // مرة واحدة بس
        }
      },
      {
        threshold: 0.25, // أسهل من 1
        rootMargin: "100px", // يبدأ بدري شوية
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  if (type === "rewards") {
    return (
      <Box
        ref={sectionRef}
        sx={{
          p: 3,
          px: 2,
          borderRadius: "15px",
          bgcolor: "white",
          m: 1,
          textAlign: "center",
          flex: "1 1 0",
          boxShadow: "2px 2px 8px lightgrey",
        }}
      >
        <Typography variant="subtitle2" sx={{ color: colors.blue }} gutterBottom>
          {text}
        </Typography>

        <Typography sx={{ color: colors.orange }} variant="h3" gutterBottom>
          {startCounting ? <CountUp start={0} end={num} duration={4} /> : 0}
        </Typography>
      </Box>
    );
  }

  if (type === "about" || type === "sustainability" || type === "why-contact") {
    const isAr = locale === "ar";

    return (
      <Box
        ref={sectionRef}
        sx={{
          p: 5,
          textAlign: "center",
          flex: "1 1 0",
          border: type === "why-contact" ? "none" : "2px solid white",
        }}
      >
        <Typography
          sx={{
            color: colors.orange,
            fontWeight: "bold",
            fontSize: { xs: "25px", md: "30px", lg: "38px" },
          }}
          variant="h3"
          gutterBottom
        >
          <span>+ </span>{" "}
          {startCounting ? (
            isAr ? (
              <CountUp
                start={0}
                end={num}
                duration={4}
                suffix={suffix ? ` ${suffix} ` : ""}
              />
            ) : (
              <CountUp start={0} end={num} duration={getDuration(num)} />
            )
          ) : (
            0
          )}
        </Typography>

        <Typography
          variant="subtitle2"
          component="h4"
          sx={{
            color: type === "why-contact" ? colors.black : colors.blue,
            fontWeight: type === "why-contact" ? 700 : undefined,
          }}
          gutterBottom
        >
          {text}
        </Typography>
      </Box>
    );
  }

  return null;
}

export default memo(Statistics);

